import { render, staticRenderFns } from "./texto-declaracao.vue?vue&type=template&id=a10f909a"
import script from "./texto-declaracao.vue?vue&type=script&lang=js"
export * from "./texto-declaracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports